import styled from '@emotion/styled'
import { getThemeSpacing } from '../styles/appTheme'
import { palette } from '../styles/colors'

export const StyledDivider = styled('div')({
    borderBottom: '1px solid ' + palette.drawerDivider,
    margin: `0 ${getThemeSpacing(2)}`,
})
